import { FC, useEffect } from 'react';
import { Box } from '@mui/material';
import styles from 'features/task/ui/FilesComponent.module.css';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import Loader from 'shared/loader/Loader';
import { Download, FileData, FileName, Files, isLoadingFiles, isLoadingTaskInfo, TaskInfo } from 'entities/task-new/selector';
import CustomButton from 'shared/custom-button/CustomButton';
import { resetFileData } from 'entities/task-new';
import { fetchFileDownload } from 'entities/task-new/actions/fetch-task-case';
import { useLocation } from 'react-router-dom';
import Pdf from 'shared/assets/pdf';
import JpgIcon from 'shared/assets/jpg';
import JpegIcon from 'shared/assets/jpeg';
import XlsIcon from 'shared/assets/xls';
import XlsxIcon from 'shared/assets/xlsx';
import XlsmIcon from 'shared/assets/xlsm';
import DocIcon from 'shared/assets/doc';
import DocxIcon from 'shared/assets/docx';
import ZipIcon from 'shared/assets/zip';
import RarIcon from 'shared/assets/rar';
import ChatAnimation from 'shared/chat-animation/ChatAnimation';

const filesIcon = [
    { name: 'pdf', icon: <Pdf /> },
    { name: 'jpg', icon: <JpgIcon /> },
    { name: 'jpeg', icon: <JpegIcon /> },
    { name: 'xls', icon: <XlsIcon /> },
    { name: 'xlsx', icon: <XlsxIcon /> },
    { name: 'xlsm', icon: <XlsmIcon /> },
    { name: 'doc', icon: <DocIcon /> },
    { name: 'docx', icon: <DocxIcon /> },
    { name: 'zip', icon: <ZipIcon /> },
    { name: 'rar', icon: <RarIcon /> },
]


export const FilesComponent: FC = () => {
    const files = useAppSelector(Files);
    const isLoading = useAppSelector(isLoadingFiles);

    const fileData = useAppSelector(FileData);
    const fileName = useAppSelector(FileName);
    const isDownload = useAppSelector(Download);
    const dispatch = useAppDispatch();

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const idTask = query.get('id');

    useEffect(() => {
        if (fileData) {
            const link = document.createElement('a');
            link.href = `data:application/octet-stream;base64,${fileData}`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            dispatch(resetFileData());
        }
    }, [fileData, isDownload, fileName, dispatch]);

    const handleDownload = async (fileId: string) => {
        if (idTask) {
            try {
                await dispatch(fetchFileDownload({
                    TaskID: idTask,
                    FileID: fileId
                }))

            } catch (error) {
                console.error('Error downloading the file:', error);
            }
        }

    };
    const getFileIcon = (fileName: string) => {
        const extension = fileName.split('.').pop()?.toLowerCase();
        const foundIcon = filesIcon.find(icon => icon.name === extension);
        return foundIcon ? foundIcon.icon : null;
    };

    const formatDateTime = (isoString: string): string => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${day}.${month}.${year} в ${hours}:${minutes}:${seconds}`;
    };
    return (
        <Box>
            {isLoading && <Loader title="Загрузка..." />}
            {!isLoading && (
                <>
                    {files.Files.length > 0 ? (
                        <Box className={styles.filesBox}>
                            {files.Files.map((file) => {
                                const icon = getFileIcon(file.Name);
                                return (
                                    <Box
                                        key={file.ID}
                                        className={styles.fileItem}
                                        onClick={() => handleDownload(file.ID)}
                                    >
                                        <Box className={styles.leftBox}>
                                            {icon && <Box className={styles.fileIcon}>{icon}</Box>}
                                            <Box className={styles.fileName}>{file.Name}</Box>
                                        </Box>

                                        <span>{formatDateTime(file.Date)}</span>
                                    </Box>
                                );
                            })}
                        </Box>
                    ) : (
                        <Box className={styles.emptyBox}>
                            <p>Пока нет ни одного файла</p>
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
};

export default FilesComponent;
